import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=08d82e4e&scoped=true"
import script from "./organizations.vue?vue&type=script&lang=js"
export * from "./organizations.vue?vue&type=script&lang=js"
import style0 from "./organizations.vue?vue&type=style&index=0&id=08d82e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d82e4e",
  null
  
)

export default component.exports